import { render, staticRenderFns } from "./TabPlanoDental.vue?vue&type=template&id=19e32b4e&scoped=true"
import script from "./TabPlanoDental.vue?vue&type=script&lang=js"
export * from "./TabPlanoDental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e32b4e",
  null
  
)

export default component.exports